import { MarqueeOverlay } from '../MarqueeOverlay';
import { SelectionHandles } from '../SelectionHandles';
import { ConnectionHandles } from '../ConnectionHandles';
import { SnapGuides } from '../SnapGuides';
import { ConnectPreview } from '../ConnectPreview';

/**
 * Interaction renderer: transient feedback for in-progress gestures (marquee, snap
 * guides, connect rubber band) and the manipulation affordances of the current
 * selection (resize/rotate handles). Lives inside the world layer so world-space
 * feedback needs no per-frame conversion; each piece subscribes to one store field.
 */
export const InteractionLayer = () => (
  <>
    <SnapGuides />
    <SelectionHandles />
    <ConnectionHandles />
    <MarqueeOverlay />
    <ConnectPreview />
  </>
);
